import './ChartValuation.scss'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import banner1 from '../../../../../assets/images/StockAnalysis/banner-1.png'
import lineMiddle from '../../../../../assets/images/StockAnalysis/line-middle.png'
import { useSelector } from 'react-redux'
import { options } from './ChartValuationConfig'
import { formatMoney } from 'Helpers/helpFunction'
import { useEffect, useState } from 'react'
import useChart from 'hook/useChart'

export default function ChartValuation() {
  const CommnonStore = useSelector((state) => state?.CommnonStore)
  const ChartStore = useSelector((state) => state?.ChartStore)
  // console.log(ChartStore?.valuesValuation, 'ChartStore');
  const [filter, setFilter] = useState({ stock: '' })
  const StocksAnalysisStore = useSelector((state) => state?.StocksAnalysisStore)
  const { fetchValueValuation } = useChart()

  useEffect(() => {
    setFilter({ stock: StocksAnalysisStore?.inputSearch })
  }, [StocksAnalysisStore?.inputSearch])

  useEffect(() => {
    fetchValueValuation({ ticker: filter.stock })
  }, [filter])

  const showDetail = Boolean(ChartStore?.valuesValuation?.stockValuation > 0)
  const potentialToIncreasePrice = Boolean(ChartStore?.valuesValuation?.potentialToIncreasePrice > 0)

  return (
    <>
      <div className='BhrhhwzDxk'>
        <div className='uwlaliOoaB'>Định giá</div>
        <div className='hQoPbBvAGL'>
          <div className='EQQwMDGXjZ'>
            <HighchartsReact
              highcharts={Highcharts}
              options={options(ChartStore?.valuesValuation, CommnonStore)}
            />
          </div>

          {
            potentialToIncreasePrice ? <>
              <div className='hTkKKbmGDH'>
                <div className='FRtbhVDtVC'>
                  <div className='VPmCTcUoSC'>{ChartStore?.valuesValuation?.potentialToIncreasePrice ? 'Tiềm năng tăng giá' : null}</div>
                  <div className='WjZIZXdknn'>{ChartStore?.valuesValuation?.potentialToIncreasePrice ?
                    `${formatMoney(ChartStore?.valuesValuation?.potentialToIncreasePrice, 2)}%` : null}</div>
                </div>
              </div>
            </> : null
          }
        </div>
        {
          showDetail ? <>
            <div className='jdJWlpOaLb'>
              <div className='geYyNqULCM'>
                <div className='hcpaQFfsKB'>
                  <div className='qHHotFYTvy'><div className='lSlFtiLncZ' style={{ backgroundColor: '#233C21' }}></div> Vùng mua</div>
                  <div className='qHHotFYTvy'><div className='lSlFtiLncZ' style={{ backgroundColor: '#3C581A' }}></div> Vùng hấp dẫn</div>
                </div>
                <div className='hcpaQFfsKB'>
                  <div className='qHHotFYTvy'><div className='lSlFtiLncZ' style={{ backgroundColor: '#514219' }}></div> Vùng theo dõi</div>
                  <div className='qHHotFYTvy'><div className='lSlFtiLncZ' style={{ backgroundColor: '#50202B' }}></div> Vùng bán</div>
                </div>
              </div>
            </div>
          </> : null
        }
      </div>
    </>
  )
}